import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-fantasy-leaderboard-v2',
  templateUrl: './fantasy-leaderboard-v2.component.html',
  styleUrl: './fantasy-leaderboard-v2.component.scss',
})
export class FantasyLeaderboardV2Component {
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
}
